import { RegularExpressions } from "../../../../../../Helpers/RegularExpression";
import { ValForm, ValFormReg } from "../../../../../../Validators/ValForms";

export const ValPedidoUnidades = (state) => {
  const nuevousado = ValForm("Nuevo o Usado", state.nuevousado);
  const modelo = ValFormReg(
    "Modelo",
    state.modelo,
    RegularExpressions.TextAndNumber
  );
  const cantidad = ValFormReg(
    "Cantidad",
    state.cantidad,
    RegularExpressions.TextOnlyNumber
  );
  const precio = ValFormReg(
    "Precio",
    state.precio,
    RegularExpressions.TextOnlyNumber
  );
  const descuento = ValFormReg(
    "Descuento",
    state.descuento,
    RegularExpressions.TextOnlyNumber
  );
  var isValid = true;
  var mensaje = "";
  if (nuevousado.isValid === false) {
    state.bnuevousado = true;
    isValid = false;
    mensaje += nuevousado.mensaje;
  }
  if (modelo.isValid === false) {
    state.bmodelo = true;
    isValid = false;
    mensaje += modelo.mensaje;
  }
  if (cantidad.isValid === false) {
    state.bcantidad = true;
    isValid = false;
    mensaje += cantidad.mensaje;
  }
  if (precio.isValid === false) {
    state.bprecio = true;
    isValid = false;
    mensaje += precio.mensaje;
  }
  if (descuento.isValid === false) {
    state.bdescuento = true;
    isValid = false;
    mensaje += descuento.mensaje;
  }
  if (isValid === false) {
    return { isValid, state, mensaje };
  } else {
    return {
      isValid,
      post: {
        folio: "",
        registro: "0",
        nuevo: state.nuevousado,
        modelo: state.modelo,
        descripcion: state.nuevousado === "Otros" ? " " : state.descripcion,
        serie:
          state.serie === undefined ||
          state.serie === null ||
          state.serie === ""
            ? " "
            : state.serie,
        cantidad: state.cantidad,
        precio: state.precio,
        descuento: state.descuento,
      },
    };
  }
};
